import Button from 'components/Button'
import { ReactComponent as NoConnection } from 'assets/images/no internet.svg'
// Function to handle reload event
export default function NoInternetConnection() {
	const handleReload = () => {
		window.location.assign(window.location.href)
	}
	return (
		<div role="alert" className="flex flex-col items-center justify-center h-full flex-1 gap-4">
			<NoConnection />
			<Button onClick={handleReload}>Try again</Button>
		</div>
	)
}
